import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import * as Accounts from './Accounts';
import * as Localizer from './Localization';
import * as Patients from './Patients';
import * as Records from './Records';
import * as MySettings from './Settings';
import * as Sites from './Sites';
import * as Sponsors from './Sponsors';
import * as Studies from './Studies';
import * as StudySites from './StudySites';


export default function configureStore(history, initialState) {

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

	const rootReducer = combineReducers({
		router: connectRouter(history),
        accounts: Accounts.reducer,
        localizer: Localizer.reducer,
        patients: Patients.reducer,
        records: Records.reducer,
        settings: MySettings.reducer,
        sites: Sites.reducer,
        sponsors: Sponsors.reducer,
        studies: Studies.reducer,
        studySites: StudySites.reducer
	})

	return createStore(
			rootReducer,
			initialState,
			compose(
				applyMiddleware(
					thunk,
					routerMiddleware(history)
					)
				, ...enhancers
				)
	);
}




// WEBPACK FOOTER //
// ./src/store/configureStore.js